// export const CREATE_INVOICES_ACCOUNT_PROGRESS = "CREATE_INVOICES_ACCOUNT_PROGRESS";
export const CREATE_INVOICES_ACCOUNT_DONE = "CREATE_INVOICES_ACCOUNT_DONE";
// export const CREATE_INVOICES_ACCOUNT_ERROR = "CREATE_INVOICES_ACCOUNT_ERROR";

export const GET_INVOICES_ACCOUNT_PROGRESS = "GET_INVOICES_ACCOUNT_PROGRESS";
export const GET_INVOICES_ACCOUNT_SUCCESS = "GET_INVOICES_ACCOUNT_SUCCESS";
export const GET_INVOICES_ACCOUNT_ERROR = "GET_INVOICES_ACCOUNT_ERROR";

// export const UPDATE_INVOICES_INFO_PROGRESS = "UPDATE_INVOICES_INFO_PROGRESS";
export const UPDATE_INVOICES_INFO_SUCCESS = "UPDATE_INVOICES_INFO_SUCCESS";
// export const UPDATE_INVOICES_INFO_ERROR = "UPDATE_INVOICES_INFO_ERROR";

export const UPDATE_INVOICES_OPTIONS_PROGRESS = "UPDATE_INVOICES_OPTIONS_PROGRESS";
export const UPDATE_INVOICES_OPTIONS_SUCCESS = "UPDATE_INVOICES_OPTIONS_SUCCESS";
export const UPDATE_INVOICES_OPTIONS_ERROR = "UPDATE_INVOICES_OPTIONS_ERROR";

export const GET_INVOICES_PROGRESS = "GET_INVOICES_PROGRESS";
export const GET_INVOICES_DONE = "GET_INVOICES_DONE";
export const GET_INVOICES_ERROR = "GET_INVOICES_ERROR";

export const DOWNLOAD_INVOICES_PROGRESS = "DOWNLOAD_INVOICES_PROGRESS";
export const DOWNLOAD_INVOICES_DONE = "DOWNLOAD_INVOICES_DONE";
export const DOWNLOAD_INVOICES_ERROR = "DOWNLOAD_INVOICES_ERROR";

export const CLEAR_INVOICES_METHODS = "CLEAR_INVOICES_METHODS";